import isDefined from './isDefined';

export default function (obj) {
    return !isDefined(obj) || obj === null || Object.keys(obj).length === 0;
}